"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productToCode = exports.productFromCode = void 0;
const errors_1 = require("@wolf/errors");
const models_1 = require("./models");
const product_v2_1 = require("./product-v2");
const types_1 = require("./types");
const utils_1 = require("./utils");
const productAI = {
    '90': 'type',
    '20': 'sourceId',
    '251': 'workspaceId',
    '21': 'productId',
    '8008': 'date',
    '240': 'index',
};
const productFromCode = (code) => {
    try {
        const codes = (0, utils_1.stringToCodes)(code);
        if ('productId' in codes) {
            return codes;
        }
        if (codes[0].value === types_1.type.productV2) {
            return (0, product_v2_1.productV2FromCode)(code);
        }
        const product = codes.reduce((previousCodes, code) => {
            return {
                ...previousCodes,
                [productAI[code.code]]: Number(code.value),
            };
        }, {});
        const productParse = models_1.ProductFromBarcode.safeParse(product);
        if (!productParse.success || productParse.data.type !== Number(types_1.type.product)) {
            throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Invalid identifier');
        }
        return productParse.data;
    }
    catch (error) {
        throw new errors_1.ApplicationError(`${error}`);
    }
};
exports.productFromCode = productFromCode;
const productToCode = (product) => {
    const swappedProduct = Object.entries(productAI).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {});
    const code = Object.keys(product).reduce((previousCode, key) => {
        return (previousCode +
            '(' +
            swappedProduct[key] +
            ')' +
            (0, utils_1.formatToCode)(product[key]));
    }, '');
    return types_1.typeIA + types_1.type.product + code;
};
exports.productToCode = productToCode;
//# sourceMappingURL=product.js.map